import { module as BaseModule } from 'modujs'
import { gsap } from 'gsap'
import Swiper, { EffectFade, Navigation } from 'swiper'
import 'swiper/css'
import 'swiper/css/effect-fade'
import 'swiper/css/navigation'

export default class extends BaseModule {
  constructor(m) {
    super(m);

    this.slider = this.el.querySelector('.kpiSlider')
    this.prev = this.el.querySelector('.kpiPrev')
    this.next = this.el.querySelector('.kpiNext')
    
    this.numbers = this.el.querySelectorAll('.kpiNumber')

    this.counting()
    this.initSwiper()
  }

  initSwiper() {
    this.swiper = new Swiper(this.slider, {
      modules: [Navigation, EffectFade],
      autoHeight: true,
      speed: 1200,
      loop: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      navigation: {
        prevEl: this.prev ,
        nextEl: this.next ,
      },
    })
  }

  counting(){
    this.numbers.forEach(number => {
      const counter = {
        value: 0,
        max : parseInt(number.getAttribute('data-kpi-number'))
      }
      number.textContent = counter.value
      gsap.to(counter, {
        value: counter.max,
        delay: 0.5,
        duration: 2.5,
        ease: 'power4.out',
        onUpdate: () => {
          number.textContent = Math.ceil(counter.value)
        }
      })
    })
  }
}
